import { PDFDocument } from "pdf-lib";
import { baseFileName } from "./file-name-core.js";

export function validateSplitRanges(ranges, pageCount) {
  if (!ranges.length) return { ranges: [], error: "Add at least one page range." };
  const normalized = [];
  const seen = new Set();
  for (let index = 0; index < ranges.length; index += 1) {
    const start = Number(ranges[index].start);
    const end = Number(ranges[index].end);
    if (!Number.isInteger(start) || !Number.isInteger(end)) {
      return { ranges: [], error: `Range ${index + 1} needs whole page numbers.` };
    }
    if (start < 1 || end < 1 || start > end || end > pageCount) {
      return { ranges: [], error: `Range ${index + 1} must be between page 1 and ${pageCount}, with the first page before the last.` };
    }
    const key = `${start}-${end}`;
    if (seen.has(key)) return { ranges: [], error: `Range ${index + 1} duplicates an earlier range.` };
    seen.add(key);
    normalized.push({ start, end });
  }
  return { ranges: normalized, error: null };
}

export function splitEntryName(fileName, range) {
  return `${baseFileName(fileName)}-pages-${range.start}-${range.end}.pdf`;
}

export function splitZipName(fileName) {
  return `${baseFileName(fileName)}-split.zip`;
}

export async function splitPdfRanges(sourceBytes, ranges, fileName, onProgress = () => {}) {
  const source = await PDFDocument.load(sourceBytes.slice(), { updateMetadata: false });
  const entries = [];
  for (let index = 0; index < ranges.length; index += 1) {
    const range = ranges[index];
    const output = await PDFDocument.create();
    output.setCreator("smallpdf.app");
    output.setProducer("smallpdf.app Split PDF");
    const indices = Array.from({ length: range.end - range.start + 1 }, (_, offset) => range.start - 1 + offset);
    const pages = await output.copyPages(source, indices);
    pages.forEach(page => output.addPage(page));
    entries.push({ name: splitEntryName(fileName, range), bytes: await output.save({ useObjectStreams: true }) });
    onProgress(index + 1, ranges.length);
  }
  return entries;
}
